import React from 'react';
import Radium from 'radium';
import AppUtil from 'AppUtil';
import {Button, Img} from 'views/AppElements';
import AppConstants from 'AppConstants';
const PAYMENT_OPTIONS = AppConstants.PAYMENT_OPTIONS;

export const PaymentOptions = () => {
    const images = Object.keys(PAYMENT_OPTIONS).map(p => PAYMENT_OPTIONS[p]).filter(p => p.image).map(p => <Img key={p.image} src={p.image} title={p.label} alt={p.label} />);
    return <div className="paymentImages flexRow">
                {images}
            </div>
};

const PaymentInfo = ({unpaidOrders}) => {
    if(unpaidOrders === null || unpaidOrders.length === 0) return null;

    const unpaidAmount = unpaidOrders.map(o => o.totalCharge).reduce((total, amount) => {
                            return total + amount;
                        });
    const unpaidOrdersId = unpaidOrders.map(o => o.orderId).join(",");
    const recentPaymentPreference = unpaidOrders[0].paymentPreference;

    let checkoutLink = "/orders/checkout?amount="+unpaidAmount+"&orderId="+unpaidOrdersId+"&via="+recentPaymentPreference;

    const unpaidOrdersCount = unpaidOrders.length;
    return <div className="flexRow" id="pendingOrdersPayment">
            <div id="orderPayInfo">
                <h3 style={{margin: '0 0 20px 0'}}>You can use any one of the following options to make your payment:</h3>
                <PaymentOptions />
            </div>

            <div className="flexColumn" id="orderSummary">
                <div id="orderPayAmount">
                    <h2 id="orderSummaryTitle">Order Summary</h2>
                    <p>- <b>{unpaidOrdersCount}</b> Order{unpaidOrdersCount > 1? 's': ''} Pending Payment</p>
                    <h3>Total Amount: <b>{"Rs. "+AppUtil.formatNumber(unpaidAmount)}</b></h3>
                    
                </div>

                <Button id="proceedToPayBtn" href={checkoutLink} variant="primary" mui="true">Proceed to Pay</Button>
            </div>
            
        </div>	
};


export default Radium(PaymentInfo);


// WEBPACK FOOTER //
// ./src/views/order/PaymentInfo.js